import { Printing, Upload, List } from 'assets/icons';
import {
  isOllas,
  isSATUploader,
  isSATPrinter,
  isB2BPrinter,
  isB2BUploader,
  canRetryShipments,
  isScanPack,
  isStaff,
  isAdmin,
  isDSVPrinter,
  isDSVRetry,
  isStock,
  isLolina,
  canReprintLabels,
  canRetrySorterShipments,
  isSAT,
  canPrintLabels,
  isBulkdrop,
} from 'modules/user-has-permission/user-has-permission';

export default function getMenuItems() {
  const ollasOrderUploads = {
    name: 'Archivos ollas',
    icon: Upload,
    path: '/ollas-upload',
  };

  const ollasPrinting = {
    name: 'Impresión ollas',
    icon: Printing,
    path: '/ollas-printer',
  };

  const satOrderUploads = {
    name: 'Archivos SAT',
    icon: Upload,
    path: '/sat-upload',
  };

  const satPrinting = {
    name: 'Impresión SAT',
    icon: Printing,
    path: '/sat-printer',
  };

  const b2bOrderUploads = {
    name: 'Archivos B2B',
    icon: Upload,
    path: '/b2b-upload',
  };

  const preparationOrdersListing = {
    name: 'Órd. de preparación',
    icon: List,
    path: '/preparation-orders',
  };

  const manifestListing = {
    name: 'Manifiestos',
    icon: List,
    path: '/manifests',
  };

  const labels = {
    name: 'Reimprimir Etiquetas',
    icon: List,
    path: '/reprint-labels',
  };

  const retryShipments = {
    name: 'Reintento envíos',
    icon: List,
    path: '/retry-shipments',
  };

  const retryScanAndPack = {
    name: 'Reintento Scan & Pack',
    icon: List,
    path: '/retry-scanpack-shipments',
  };

  const retryLolina = {
    name: 'Reintento Lolina',
    icon: List,
    path: '/retry-lolina-shipments',
  };

  const retryBulkdrop = {
    name: 'Reintento Bulkdrop',
    icon: List,
    path: '/retry-bulkdrop-shipments',
  };

  const retrySorter = {
    name: 'Reintentos Whales',
    icon: List,
    path: '/retry-sorter-shipments',
  };

  const configuration = {
    name: 'Configuración',
    icon: List,
    path: '/configuration',
  };

  const warehouseManagement = {
    name: 'Gestión de almacén',
    icon: List,
    path: '/warehouse-management',
  };

  const dsvPendingOrders = {
    name: 'Pedidos pendientes',
    icon: List,
    path: '/dsv/pending-orders',
  };

  const menuItems = [];

  if (isOllas()) {
    menuItems.push(ollasOrderUploads);
    menuItems.push(ollasPrinting);
  }

  if (isSATUploader()) menuItems.push(satOrderUploads);

  if (isSATPrinter()) menuItems.push(satPrinting);

  if (isB2BUploader()) menuItems.push(b2bOrderUploads);

  if ((isB2BPrinter() || isDSVPrinter()) && !isStock()) {
    menuItems.push(preparationOrdersListing);
    menuItems.push(manifestListing);
  }

  if (isStock()) {
    menuItems.push(preparationOrdersListing);
  }

  if (canRetryShipments()) menuItems.push(retryShipments);

  if (isScanPack()) menuItems.push(retryScanAndPack);

  if (isLolina()) menuItems.push(retryLolina);

  if (isBulkdrop()) menuItems.push(retryBulkdrop);

  if (canRetrySorterShipments()) menuItems.push(retrySorter);

  if (isAdmin()) menuItems.push(configuration);

  if (isStaff()) menuItems.push(warehouseManagement);
  if (isStaff() || canReprintLabels()) menuItems.push(labels);

  if (isDSVRetry()) menuItems.push(dsvPendingOrders);

  if (isSAT() && canPrintLabels()) menuItems.push(manifestListing);

  return menuItems;
}
